var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tree',{ref:"resTree",attrs:{"data":_vm.tree},on:{"on-select-change":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }